export default __webpack_public_path__ + "static/media/base-report3.343ec6b9.png";